
// region JS Imports

// region External Modules
import u from "umbrellajs"
// endregion External Modules

// Private Modules
import {
  captureMessage,
} from "app/error_reporting"

import {
  get_many as get_current_authenticated_user_buildings_shortlisted,
  ResultTypeEnums as GetCurrentAuthenticatedUserBuildingsShortlistedTypes,
} from "app/resources/current_authenticated_user/buildings_shortlisted/get_many/index"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import { Factory } from "./factory"
// endregion Private Components

// endregion JS Imports

const CELL_CLASS_NAME = "cell--buildings--shortlist-button--icon-only"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const initAllMatchingElements = () => {
  return get_current_authenticated_user_buildings_shortlisted()
  .then(({result_type, data}) => {
    switch (result_type) {
      case GetCurrentAuthenticatedUserBuildingsShortlistedTypes.SUCCESS:
      case GetCurrentAuthenticatedUserBuildingsShortlistedTypes.NOT_SIGNED_IN:
      case GetCurrentAuthenticatedUserBuildingsShortlistedTypes.SERVER_ERROR:
      case GetCurrentAuthenticatedUserBuildingsShortlistedTypes.TOO_MANY_REQUEST:
        return data || []
      default:
        captureMessage(
          `unexpected/unhandled result_type from get_current_authenticated_user_buildings_shortlisted: <${result_type}>`,
          {
            source_file_path:
              "apps/spacious_website/components/buildings/shortlist_button/icon_only",
          }
        )
        // Still need to init elements
        return []
    }
  })
  .then((buildings) => {
    u(`.${CELL_CLASS_NAME}`).each((el) => {
      if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
      el.classList.add(CELL_INITIALIZED_CLASS_NAME)

      Factory.create({
        container: el,

        shortlisted_resource_ids: buildings.map((b) => b.id),
      })
    })
  })
}


export {
  initAllMatchingElements,
}
